module.exports = __webpack_public_path__ + "img/vertical_3_7_9006.beea1272.png";